var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.test}},[_vm._v("adddd")]),_vm._v(" "),_c('ul',{staticClass:"items"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"item",style:({height:item + 'px'})},[_vm._v("\n            "+_vm._s(item)+"\n        ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a21532b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/test.vue
// module id = null
// module chunks = 